import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import './numberInput.scss';
function NumberInput({ onChange, label, name, errorMessage, value, placeholder, icon }) {
    return (_jsxs("div", { className: errorMessage ? 'number-input--error' : 'number-input', children: [_jsxs("label", { htmlFor: name, children: [_jsx("span", { className: "label", children: label }), _jsx("input", { name: name, value: value, onChange: onChange, placeholder: placeholder, type: "text" }), icon && _jsx("span", { className: "icon", children: icon })] }), errorMessage && _jsx("div", { className: "error-message", children: errorMessage })] }));
}
NumberInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string,
    errorMessage: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    icon: PropTypes.string,
};
NumberInput.defaultProps = {
    name: null,
    errorMessage: '',
    value: '',
    placeholder: '',
    icon: null,
};
export default NumberInput;
